<template>
    <div class="sidebar-sticky">
        <!-- <div v-if="categories && categories.length" class="card mb-4 rounded-4">
            <div class="card-header fw-bold bg-light border-0 rounded-top-4 py-3">{{ TR.categories }}</div>
            <div class="card-body">
                <ul class="list-group list-group-flush">
                    <li v-for="(item, index) in categories" :key="index" class="list-group-item">
                        {{ item.name }}
                        <span class="badge rounded-pill px-2 py-1" :class="item.post_count > 100 ? 'bg-success' : item.post_count > 50 ? 'bg-warning' : 'bg-danger'">{{ item.post_count }}</span>
                    </li>
                </ul>
            </div>
        </div> -->

        <div class="vector-header vector-header-wide mb-4" style="--h: 60px">
            <div class="row m-0 w-100 d-flex align-items-center home-sidebar-title">
                <div class="col-7 ps-3 fw-semibold">{{ TR.authors }}</div>
                <div class="col-5 text-end">
                    <router-link :to="{name: 'authors'}" class="btn1 text-primary">{{ TR.others }} <i class="fas fa-angle-double-right"></i></router-link>
                </div>
            </div>
        </div>

        <div class="card border-0 rounded-4">
            <div class="card-body pt-4">
                <div v-for="(author, index) in data" :key="index" class="d-flex align-items-center author_div">
                    <template v-if="author.publish != 0">
                        <!-- <router-link :to="{'name': 'post_paging', params: { page: 1, perpage: G.rowsPerPage, category_id: 0, author_id: author.id || 0, search_text: '' }}" class="d-flex align-items-center mb-3 nav-link"> -->
                        <!-- <router-link :to="{'name': 'author_post_paging', params: { page: 1, perpage: G.rowsPerPage, author_name: author.username, author_id: author.id || 0 }}" class="d-flex align-items-center mb-3 nav-link"> -->
                        <router-link :to="{'name': 'author_detail', params: { author_name: author.username, author_id: author.id || 0 }}" class="d-flex align-items-center mb-3 nav-link author_image">
                            <img :src="author?.image" class="author-avatar me-3" />
                        </router-link>
                        <router-link :to="{'name': 'post_detail', params: { id: author.last_post.id }}" class="mb-3 text-dark nav-link w-100">
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="fw-semibold">{{ author.translate[0].firstname }} {{ author.translate[0].lastname }}</span>
                                <span class="text-muted small">{{ author.last_post.create_date }}</span>
                            </div>
                            <div class="w-1001">{{ $filters.stripTags(author.last_post.translate ? author.last_post.translate[0].title : '').substring(0, 60) }}...</div>
                        </router-link>
                    </template>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { ref, watchEffect } from 'vue';

import { useStore } from "@/system_modules/store";

import { G } from "@/_common";

export default {
    name: 'HomeSidebarC',
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    setup() {
        const store = useStore();
        const TR = ref({});

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        return {
            G,
            TR,
        };
    },
}
</script>


<style lang="scss" scoped>
.sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 100px;
}

.sidebar-sticky .list-group-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sidebar-sticky .badge {
    font-size: 0.75rem;
}

.author-avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
}
.home-sidebar-title{
    font-size: 14pt;
}
.author_image:hover img{
    border: 2px solid var(--bs-primary);
}
.author_div:hover{
    // background: rgba(var(--bs-secondary-rgb), .1);
    border-radius: 10px;
    box-shadow: -10px -10px 15px rgba(14, 46, 63, .18);;
}
@media(max-width: 820px) {
    .home-sidebar-title{
        font-size: 12pt;
    }
}
</style>